import { filterableContentOf } from "../../utils/filterableContentOf";
import { multilingualBlockContentPreview } from "./multilingualArrayBlockContent";
import { multilingualArrayBlockContent } from "./index";

const subtitleMaxLength = 100;
const subtitlePreview = multilingualBlockContentPreview(subtitleMaxLength);

export default filterableContentOf(
  multilingualArrayBlockContent.name,
  subtitlePreview,
  "filterableMultilingualBlockContent"
);
